import React, { useEffect, useState, useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getAccessToken } from "../../token";
import { API_URL } from "../../Constants";
import { motion, AnimatePresence } from "framer-motion";

// --- Icons ---
const FiFileText = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12 a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
const FiUser = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>;
const FiType = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" /></svg>;
const FiSend = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>;
const FiClock = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14" /></svg>;
const FiRefreshCw = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>;
const FiHash = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="4" y1="9" x2="20" y2="9" /><line x1="4" y1="15" x2="20" y2="15" /><line x1="10" y1="3" x2="8" y2="21" /><line x1="16" y1="3" x2="14" y2="21" /></svg>;
const FiMessageSquare = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>;
const FiPlay = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>;
const FiPause = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>;
const FiCalendar = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>;
const FiBarChart2 = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>;
const FiCheckCircle = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const FiX = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>;
const FiPlus = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
const FiPlayCircle = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>;
const FiSearch = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>;
const FiUsers = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const FiClipboard = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M16 4h2a2 2 0 0 1-2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>;
const FiAlertTriangle = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>;
const FiChevronLeft = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="15 18 9 12 15 6"></polyline></svg>;
const FiChevronRight = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="9 18 15 12 9 6"></polyline></svg>;
const FiEye = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const FiCopy = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>;
const FiAlertCircle = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>;
const FiTarget = ({ size = 16, className = "" }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>;

const ACTIVE_STATUSES = ['RUNNING', 'PAUSED'];
const POLL_INTERVAL_MS = 3000;

const formatDateArray = (dateValue) => {
  if (!dateValue) return 'N/A';
  try {
    if (typeof dateValue === 'string') {
      const date = new Date(dateValue);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
    if (Array.isArray(dateValue) && dateValue.length >= 5) {
      const [year, month, day, hour, minute, second] = dateValue;
      const date = new Date(year, month - 1, day, hour, minute, second || 0);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
    return 'N/A';
  } catch { return 'Invalid Date'; }
};

const countValidNumbers = (text) => {
  if (!text) return 0;
  return text.split(/[\s,]+/).filter(num => /^\d{10}$/.test(num)).length;
};

const paiseToRupees = (paise, decimal =2) => {
  if (paise == null || isNaN(paise)) return '₹0.00';
  return '₹' + (paise / 100000).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
// ✅ NEW — add this
const millipaiseToPaise = (millipaise) => {
  if (millipaise == null || isNaN(millipaise)) return '0 paise';
  return (millipaise / 1000).toFixed(2).replace(/\.00$/, '') + ' paise';
};

const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return "0.0";

  // Convert millipaise to paise
  const amountInPaise = amount / 100000;

  // Format with exactly 1 decimal digit
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amountInPaise);
};
const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const calculate = () => {
      const now = new Date();
      const target = new Date(targetDate);
      const diff = target - now;

      if (diff <= 0) return "Starting soon...";

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);

      return `${hours}h ${mins}m ${secs}s`;
    };

    const timer = setInterval(() => setTimeLeft(calculate()), 1000);
    setTimeLeft(calculate());
    return () => clearInterval(timer);
  }, [targetDate]);

  return <span className="font-mono text-[10px] text-purple-600 font-bold bg-purple-50 px-1.5 py-0.5 rounded border border-purple-100">{timeLeft}</span>;
};

const FormInput = ({ label, icon: Icon, note, className = "", ...props }) => (
  <div className={`mb-4 ${className}`}>
    <label className="block text-sm font-semibold text-gray-700 mb-1">
      {label} {props.required && <span className="text-red-500 ml-1">*</span>}
    </label>
    <div className="relative">
      <input {...props} className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#126673] focus:border-transparent outline-none transition-all duration-300 hover:border-[#0C4550]/50" />
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400">{Icon && <Icon size={18} />}</div>
    </div>
    {note && <p className="mt-1 text-xs text-gray-500">{note}</p>}
  </div>
);

const FormSelect = ({ label, icon: Icon, options, note, className = "", ...props }) => (
  <div className={`mb-4 ${className}`}>
    <label className="block text-sm font-semibold text-gray-700 mb-1">
      {label} {props.required && <span className="text-red-500 ml-1">*</span>}
    </label>
    <div className="relative">
      <select {...props} className="w-full pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#126673] focus:border-transparent outline-none appearance-none cursor-pointer transition-all duration-300 hover:border-[#0C4550]/50">
        {options.map((opt) => (<option key={opt.value} value={opt.value} disabled={opt.disabled}>{opt.label}</option>))}
      </select>
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400">{Icon && <Icon size={18} />}</div>
      <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
      </div>
    </div>
    {note && <p className="mt-1 text-xs text-gray-500">{note}</p>}
  </div>
);

const TemplateContentField = ({ label, icon: Icon, value, onChange, charCount, maxLength = 160, encodingLabel = "GSM-7", ...props }) => (
  <div className="mb-4">
    <div className="flex justify-between items-center mb-1">
      <label className="block text-sm font-semibold text-gray-700">{label} <span className="text-red-500 ml-1">*</span></label>
      <div className="flex items-center gap-2">
        <span className="text-[9px] font-extrabold text-[#0C4550]/40 px-1.5 py-0.5 border border-[#0C4550]/10 rounded bg-gray-50 font-manrope">{encodingLabel}</span>
        <span className={`text-xs font-medium ${charCount > maxLength ? 'text-red-500' : 'text-gray-500'}`}>{charCount}/{maxLength}</span>
      </div>
    </div>
    <div className="relative">
      <textarea {...props} value={value} onChange={onChange} rows="3" className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#126673] focus:border-transparent outline-none transition-all duration-300 hover:border-[#0C4550]/50 resize-none" />
      <div className="absolute top-3 left-3 pointer-events-none text-gray-400">{Icon && <Icon size={18} />}</div>
    </div>
  </div>
);

const EarlyStartModal = ({ isOpen, onClose, onConfirm, campaign }) => {
  if (!isOpen || !campaign) return null;
  return (
    <div className="fixed inset-0 bg-gray-900/70 backdrop-blur-sm flex items-center justify-center p-4 z-[80] transition-all duration-300">
      <div className="bg-[#F0EFEB] rounded-3xl shadow-2xl w-full max-w-sm transform transition-all scale-100 overflow-hidden text-center">
        <div className="bg-[#0C4550] px-5 py-3 flex items-center justify-between">
          <span className="text-xs font-bold text-white uppercase tracking-widest">Start Scheduled Campaign?</span>
          <button onClick={onClose} className="text-white/70 hover:text-white transition-colors"><FiX size={18} /></button>
        </div>
        <div className="p-8">
          <div className="w-16 h-16 bg-[#EEF2FC] rounded-full flex items-center justify-center mx-auto mb-6">
            <FiClock size={32} className="text-indigo-600 animate-pulse" />
          </div>
          <h3 className="text-xl font-black text-gray-900 mb-2">Wait or Start Now?</h3>
          <p className="text-sm text-gray-700 leading-relaxed px-2">
            This campaign is scheduled for <span className="font-bold text-gray-800">{formatDateArray(campaign.scheduledAt)}</span>.
            Do you want to start it immediately or wait for the scheduled time?
          </p>

          <div className="mt-6 flex flex-col items-center gap-3">
            <div className="bg-purple-50 border border-purple-100 rounded-xl px-6 py-3">
              <p className="text-[10px] font-bold text-purple-500 uppercase tracking-widest mb-1">Remaining Time</p>
              <CountdownTimer targetDate={campaign.scheduledAt} />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 p-4 gap-3 bg-gray-50 border-t border-gray-100">
          <button onClick={onClose} className="py-3.5 px-4 bg-white border border-gray-300 text-gray-800 text-sm font-bold rounded-2xl transition-all active:scale-95">
            Wait
          </button>
          <button onClick={onConfirm} className="py-3.5 px-4 bg-[#0C4550] text-white text-sm font-bold rounded-2xl shadow-lg shadow-teal-900/20 transition-all active:scale-95">
            Yes, Start Now
          </button>
        </div>
      </div>
    </div>
  );
};

const RelaunchModal = ({ isOpen, onClose, onSubmit, campaign, senderIdOptions, dltTemplates, isSubmitting }) => {
  const [formData, setFormData] = useState({
    campaignName: '',
    senderId: '',
    templateName: '',
    templateId: '',
    messageContent: '',
    targetAudience: 'DELIVERED',
    isScheduled: false,
    scheduledAt: ''
  });

  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [smsLimit, setSmsLimit] = useState(160);
  const [encodingLabel, setEncodingLabel] = useState("GSM-7");
  const [showLimitWarning, setShowLimitWarning] = useState(false);
  const scheduleSectionRef = useRef(null);

  useEffect(() => {
    if (isOpen && campaign) {
      const temp = dltTemplates.find(t => t.templateId === campaign.templateId);
      setFormData({
        campaignName: `${campaign.campaignName || campaign.name} - Retarget`,
        senderId: campaign.senderId || '',
        templateName: temp ? temp.templateName : '',
        templateId: campaign.templateId || '',
        messageContent: campaign.messageContent || '',
        targetAudience: 'DELIVERED',
        isScheduled: false,
        scheduledAt: ''
      });
    }
  }, [isOpen, campaign, dltTemplates]);

  useEffect(() => {
    if (formData.senderId) {
      const filtered = dltTemplates.filter(t => t.senderIds && t.senderIds.includes(formData.senderId));
      setFilteredTemplates(filtered);
    } else {
      setFilteredTemplates([]);
    }
  }, [formData.senderId, dltTemplates]);

  useEffect(() => {
    if (formData.isScheduled && scheduleSectionRef.current) {
      scheduleSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [formData.isScheduled]);

  useEffect(() => {
    const detectEncoding = (text) => {
      const gsm7Basic = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
      const gsm7Extended = "^{}\\[]~|€";
      for (let i = 0; i < text.length; i++) {
        if (!gsm7Basic.includes(text[i]) && !gsm7Extended.includes(text[i])) return "UNICODE";
      }
      return "GSM-7";
    };

    const encoding = detectEncoding(formData.messageContent);
    const limit = encoding === "UNICODE" ? 70 : 160;

    setEncodingLabel(encoding);
    setSmsLimit(limit);
    setShowLimitWarning(formData.messageContent.length > limit);
  }, [formData.messageContent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "senderId") {
      setFormData(prev => ({ ...prev, [name]: value, templateName: "", templateId: "", messageContent: "" }));
    } else if (name === "templateName") {
      const template = dltTemplates.find(t => t.templateName === value);
      setFormData(prev => ({
        ...prev,
        templateName: value,
        templateId: template ? template.templateId : "",
        messageContent: template ? template.content : ""
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  if (!isOpen || !campaign) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-50 transition-all duration-300">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[95vh] overflow-hidden flex flex-col transform transition-all scale-100">
        <div className="bg-[#0C4550] px-6 py-5 flex items-center justify-between shrink-0">
          <div>
            <h2 className="text-xl font-bold text-white tracking-wide flex items-center gap-2">
              <FiTarget size={20} /> Retarget Campaign Contacts
            </h2>
            <p className="text-sm text-[#A7A08F] mt-1">From campaign: {campaign.campaignName || campaign.name}</p>
          </div>
          <button onClick={onClose} className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-colors"><FiX size={24} /></button>
        </div>

        <div className="overflow-y-auto p-6 md:p-8 space-y-4">
          <form id="relaunch-form" onSubmit={(e) => { e.preventDefault(); onSubmit(formData); }}>
            <div className="mb-4">
              <label className="block text-sm font-bold text-gray-800 mb-2">Target Audience Center</label>
              <div className="flex gap-2 bg-white/60 p-1.5 rounded-xl border border-gray-200/50 shadow-sm w-fit">
                <button
                  type="button"
                  className={`px-6 py-2 rounded-lg text-sm font-bold font-manrope transition-all duration-300 ${formData.targetAudience === 'DELIVERED' ? 'bg-[#0C4550] text-white shadow-md' : 'text-[#0C4550] hover:bg-[#0C4550]/10'
                    }`}
                  onClick={() => handleChange({ target: { name: 'targetAudience', value: 'DELIVERED' } })}
                >
                  Delivered Numbers
                </button>
                <button
                  type="button"
                  className={`px-6 py-2 rounded-lg text-sm font-bold font-manrope transition-all duration-300 ${formData.targetAudience === 'FAILED' ? 'bg-[#0C4550] text-white shadow-md' : 'text-[#0C4550] hover:bg-[#0C4550]/10'
                    }`}
                  onClick={() => handleChange({ target: { name: 'targetAudience', value: 'FAILED' } })}
                >
                  Failed Numbers
                </button>
              </div>
            </div>

            <div className={`border rounded-lg p-3 mb-4 text-sm ${formData.targetAudience === 'DELIVERED' ? 'bg-green-50 border-green-100 text-green-800' : 'bg-red-50 border-red-100 text-red-800'}`}>
              <p><strong>Note:</strong> This will create a new campaign targeting <em>only</em> the numbers that were <strong>{formData.targetAudience === 'DELIVERED' ? 'successfully DELIVERED' : 'FAILED or UNDELIVERED'}</strong> in the original campaign.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FormInput label="New Campaign Name" name="campaignName" value={formData.campaignName} onChange={handleChange} placeholder="e.g., Diwali Sale - Retarget" icon={FiType} required />
              <FormSelect label="Sender ID" name="senderId" value={formData.senderId} onChange={handleChange} icon={FiUser} required options={senderIdOptions} />
              <FormSelect
                label="Template Name"
                name="templateName"
                value={formData.templateName}
                onChange={handleChange}
                icon={FiFileText}
                required
                options={[
                  { value: "", label: "Select Template Name", disabled: true },
                  ...filteredTemplates.map(t => ({ value: t.templateName, label: t.templateName }))
                ]}
              />
              <FormInput
                label="Template ID"
                name="templateId"
                value={formData.templateId}
                readOnly
                placeholder="Auto-filled from template..."
                icon={FiHash}
              />
            </div>

            <div className="mt-2">
              <TemplateContentField
                label="Message Content"
                name="messageContent"
                value={formData.messageContent}
                onChange={handleChange}
                icon={FiMessageSquare}
                placeholder="Content auto-fills on Template selection..."
                charCount={formData.messageContent.length}
                maxLength={smsLimit}
                encodingLabel={encodingLabel}
                required
              />

              <AnimatePresence>
                {showLimitWarning && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-xl flex items-start gap-3 shadow-sm"
                  >
                    <div className="mt-0.5 text-orange-500"><FiAlertCircle size={18} /></div>
                    <div>
                      <p className="text-[11px] font-bold text-orange-800 uppercase">Message Limit Exceeded</p>
                      <p className="text-[10px] text-orange-700 font-medium leading-tight mt-0.5">
                        Your message exceeds the {smsLimit} character limit for {encodingLabel} encoding.
                        It will be charged as <span className="font-bold">2 or more messages</span> per contact.
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            <div className="mt-6 border-t border-gray-100 pt-6" ref={scheduleSectionRef}>
              <div className="flex items-center justify-between bg-indigo-50 p-4 rounded-xl border border-indigo-50">
                <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-lg transition-colors bg-white text-indigo-600`}>
                    <FiCalendar size={20} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-indigo-600">Schedule Retargeting</h4>
                    <p className="text-[11px] text-gray-600">Optional — if you want to delay this campaign.</p>
                  </div>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" name="isScheduled" checked={formData.isScheduled} onChange={(e) => handleChange({ target: { name: 'isScheduled', value: e.target.checked } })} className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gray-800"></div>
                </label>
              </div>

              {formData.isScheduled && (
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 animate-fadeIn">
                  <FormInput
                    label="Schedule Date & Time"
                    name="scheduledAt"
                    type="datetime-local"
                    value={formData.scheduledAt}
                    onChange={handleChange}
                    icon={FiClock}
                    required={formData.isScheduled}
                    min={new Date().toISOString().slice(0, 16)}
                  />
                  <div className="flex items-center bg-blue-50/50 border border-blue-100 rounded-lg p-3">
                    <p className="text-[11px] text-slate-800 leading-tight">
                      <strong>Note:</strong> Campaign will automatically start at the selected time. Ensure your wallet has sufficient balance.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 flex justify-end gap-4 shrink-0">
          <button type="button" onClick={onClose} className="px-6 py-2.5 text-gray-700 font-semibold rounded-xl border border-gray-300 bg-white shadow-sm transition-all duration-200 hover:bg-gray-100 active:scale-95">Cancel</button>
          <button type="submit" form="relaunch-form" disabled={isSubmitting} className="px-8 py-2.5 bg-[#0C4550] text-white font-semibold rounded-xl shadow-md transition-all duration-200 hover:bg-[#09353E] hover:shadow-lg active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
            {isSubmitting ? (<><div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> Processing...</>) : (<><FiTarget size={18} /> Relaunch Now</>)}
          </button>
        </div>
      </div>
    </div>
  );
};

const ViewReportModal = ({ isOpen, onClose, campaignId }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [searchMobile, setSearchMobile] = useState("");
  const [totalElements, setTotalElements] = useState(0);
  const [previewMsg, setPreviewMsg] = useState(null);
  const token = getAccessToken();
  const size = 20;

  const fetchMessages = useCallback(async (pageNum, mobile = "") => {
    setLoading(true);
    try {
      let url = `${API_URL}/api/reports/campaigns/${campaignId}/messages?page=${pageNum}&size=${size}`;
      if (mobile) url += `&mobile=${mobile}`;

      const response = await fetch(url, {
        headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" }
      });
      const result = await response.json();
      if (response.ok) {
        setMessages(result.content || result.data || []);
        setTotalElements(result.totalElements || 0);
      }
    } catch (err) {
      console.error("Report fetch error:", err);
    } finally {
      setLoading(false);
    }
  }, [campaignId, token]);

  useEffect(() => {
    if (isOpen && campaignId) {
      setPage(0);
      setSearchMobile("");
      fetchMessages(0, "");
    }
  }, [isOpen, campaignId, fetchMessages]);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchMobile(val);
    setPage(0);
    fetchMessages(0, val);
  };

  const handlePrev = () => {
    if (page > 0) {
      const prevPage = page - 1;
      setPage(prevPage);
      fetchMessages(prevPage, searchMobile);
    }
  };

  const handleNext = () => {
    const nextPage = page + 1;
    if ((nextPage * size) < totalElements) {
      setPage(nextPage);
      fetchMessages(nextPage, searchMobile);
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  const truncateContent = (text) => {
    if (!text) return '—';
    const words = text.split(' ');
    if (words.length <= 5) return text;
    return words.slice(0, 5).join(' ') + '...';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/70 backdrop-blur-sm flex items-center justify-center p-4 z-[100] transition-all duration-300">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[80vh] flex flex-col overflow-hidden transform transition-all scale-100 border border-gray-200">
        <div className="bg-[#0C4550] px-6 py-4 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-3">
            <FiEye className="text-white" size={20} />
            <h2 className="text-lg font-bold text-white tracking-tight">Campaign Report</h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="Mobile..."
                value={searchMobile}
                onChange={handleSearch}
                className="pl-8 pr-3 py-1.5 rounded-lg text-xs outline-none border-none focus:ring-2 focus:ring-teal-400 w-32 md:w-48 bg-white/10 text-white placeholder-white/50"
              />
              <FiSearch className="absolute left-2.5 top-2 text-white/50" size={14} />
            </div>
            <button onClick={onClose} className="p-1 text-white/70 hover:text-white transition-colors"><FiX size={20} /></button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto bg-gray-50 overflow-x-hidden">
          {loading ? (
            <div className="flex flex-col items-center justify-center h-full gap-2">
              <div className="w-8 h-8 border-3 border-[#0C4550] border-t-transparent rounded-full animate-spin"></div>
              <p className="text-xs text-gray-500">Loading Report...</p>
            </div>
          ) : messages.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-gray-400">
              <FiFileText size={40} className="mb-2 opacity-20" />
              <p className="text-sm">No data available.</p>
            </div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200 table-fixed border-collapse">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="w-[5%] px-3 py-3 text-left text-[10px] font-bold text-gray-500 uppercase">#</th>
                  <th className="w-[15%] px-3 py-3 text-left text-[10px] font-bold text-gray-500 uppercase">Submitted</th>
                  <th className="w-[13%] px-3 py-3 text-left text-[10px] font-bold text-gray-500 uppercase">Msg ID</th>
                  <th className="w-[13%] px-3 py-3 text-left text-[10px] font-bold text-gray-500 uppercase">Recipient</th>
                  <th className="w-[25%] px-3 py-3 text-left text-[10px] font-bold text-gray-500 uppercase">Content</th>
                  <th className="w-[10%] px-3 py-3 text-left text-[10px] font-bold text-gray-500 uppercase">Status</th>
                  <th className="w-[10%] px-3 py-3 text-right text-[10px] font-bold text-gray-500 uppercase">Cost</th>
                  <th className="w-[9%] px-3 py-3 text-right text-[10px] font-bold text-gray-500 uppercase">Refund</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {messages.map((m, idx) => (
                  <tr key={idx} className="hover:bg-gray-50 transition-colors">
                    <td className="px-3 py-3 text-[11px] font-medium text-gray-400">{(page * size) + idx + 1}</td>
                    <td className="px-3 py-3 whitespace-nowrap text-[11px] text-gray-600 truncate">{m.submittedAt ? formatDateArray(m.submittedAt) : 'N/A'}</td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <div className="flex items-center gap-1.5 group">
                        <span className="text-[10px] font-mono text-gray-400 truncate max-w-[80px]">{m.messageId || '—'}</span>
                        {m.messageId && (
                          <button onClick={() => handleCopy(m.messageId)} className="text-gray-300 hover:text-indigo-500 transition-colors" title="Copy ID">
                            <FiCopy size={12} />
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-[11px] font-bold text-gray-900 truncate">{m.mobile || m.recipient}</td>
                    <td className="px-3 py-3">
                      <div className="flex items-center justify-between gap-2 bg-gray-50/50 px-2 py-1 rounded border border-gray-100">
                        <span className="text-[11px] text-gray-600 truncate">{truncateContent(m.content)}</span>
                        <button
                          onClick={() => setPreviewMsg(m.content)}
                          className="text-indigo-500 hover:text-indigo-700 shrink-0 transition-transform active:scale-90"
                          title="View Full Content"
                        >
                          <FiEye size={14} />
                        </button>
                      </div>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <span className={`px-2 py-0.5 rounded-full text-[9px] font-bold uppercase ${(m.detailedStatus || m.status) === 'DELIVERED' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'
                        }`}>
                        {m.detailedStatus || m.status}
                      </span>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-[11px] font-mono font-bold text-right text-[#334155]">
                      {formatCurrency(m.cost)}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-[11px] font-mono font-bold text-right">
                      {m.refundedAmount > 0 ? (
                        <span className="text-emerald-600">+{formatCurrency(m.refundedAmount)}</span>
                      ) : (
                        <span className="text-gray-400">{formatCurrency(0)}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="px-6 py-3 bg-white border-t border-gray-200 flex items-center justify-between shrink-0">
          <div className="text-[10px] font-medium text-gray-500 uppercase">
            Showing <span className="text-black">{messages.length > 0 ? page * size + 1 : 0}-{page * size + messages.length}</span> of <span className="text-black">{totalElements}</span>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={handlePrev} disabled={page === 0 || loading} className="p-1.5 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-30"><FiChevronLeft size={14} /></button>
            <div className="text-[11px] font-bold text-[#0C4550] px-2">Page {page + 1}</div>
            <button onClick={handleNext} disabled={((page + 1) * size) >= totalElements || loading} className="p-1.5 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-30"><FiChevronRight size={14} /></button>
          </div>
        </div>
      </div>

      {previewMsg && (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-6 bg-black/40 animate-fadeIn">
          <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md w-full relative">
            <button onClick={() => setPreviewMsg(null)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"><FiX size={18} /></button>
            <h4 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-2"><FiMessageSquare size={14} /> Full Content</h4>
            <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-700 leading-relaxed border border-gray-100 max-h-60 overflow-y-auto italic">
              {previewMsg}
            </div>
            <button onClick={() => setPreviewMsg(null)} className="mt-4 w-full py-2 bg-[#0C4550] text-white rounded-lg text-xs font-bold">Close Preview</button>
          </div>
        </div>
      )}
    </div>
  );
};

const CampaignModal = ({ isOpen, onClose, onSubmit, formData, handleChange, isSubmitting, senderIdOptions, contactGroupOptions, templates }) => {
  const scheduleSectionRef = useRef(null);
  const [filteredTemplates, setFilteredTemplates] = useState([]);

  const [smsLimit, setSmsLimit] = useState(160);
  const [encodingLabel, setEncodingLabel] = useState("GSM-7");
  const [showLimitWarning, setShowLimitWarning] = useState(false);

  useEffect(() => {
    if (formData.isScheduled && scheduleSectionRef.current) {
      scheduleSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [formData.isScheduled]);

  useEffect(() => {
    if (formData.templateName && scheduleSectionRef.current) {
      scheduleSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [formData.templateName]);

  useEffect(() => {
    if (formData.senderId) {
      const filtered = templates.filter(t => t.senderIds && t.senderIds.includes(formData.senderId));
      setFilteredTemplates(filtered);
    } else {
      setFilteredTemplates([]);
    }
  }, [formData.senderId, templates]);

  useEffect(() => {
    const detectEncoding = (text) => {
      const gsm7Basic = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
      const gsm7Extended = "^{}\\[]~|€";
      for (let i = 0; i < text.length; i++) {
        if (!gsm7Basic.includes(text[i]) && !gsm7Extended.includes(text[i])) return "UNICODE";
      }
      return "GSM-7";
    };

    const encoding = detectEncoding(formData.messageContent);
    const limit = encoding === "UNICODE" ? 70 : 160;

    setEncodingLabel(encoding);
    setSmsLimit(limit);
    setShowLimitWarning(formData.messageContent.length > limit);
  }, [formData.messageContent]);

  if (!isOpen) return null;
  const validNumbersCount = countValidNumbers(formData.rawNumbers);
  const isOverLimit = validNumbersCount > 100000;

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-center justify-center p-4 z-50 transition-all duration-300">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[95vh] overflow-hidden flex flex-col transform transition-all scale-100">
        <div className="bg-[#0C4550] px-6 py-5 flex items-center justify-between shrink-0">
          <div><h2 className="text-xl font-bold text-white tracking-wide">New Campaign</h2><p className="text-sm text-[#A7A08F] mt-1">Configure your SMS details below</p></div>
          <button onClick={onClose} className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-colors"><FiX size={24} /></button>
        </div>
        <div className="overflow-y-auto p-6 md:p-8 space-y-4">
          <div className="flex gap-2 bg-white/60 p-1.5 rounded-xl border border-gray-100 shadow-sm w-fit mb-4 mx-auto">
            <button type="button" onClick={() => handleChange({ target: { name: 'campaignMode', value: 'UPLOADED' } })} className={`px-6 py-2 rounded-lg text-sm font-bold transition-all duration-300 flex items-center gap-2 ${formData.campaignMode === 'UPLOADED' ? 'bg-[#0C4550] text-white shadow-md' : 'text-[#0C4550] hover:bg-[#0C4550]/10'}`}><FiUsers size={16} /> Uploaded Contacts</button>
            <button type="button" onClick={() => handleChange({ target: { name: 'campaignMode', value: 'PASTED' } })} className={`px-6 py-2 rounded-lg text-sm font-bold transition-all duration-300 flex items-center gap-2 ${formData.campaignMode === 'PASTED' ? 'bg-[#0C4550] text-white shadow-md' : 'text-[#0C4550] hover:bg-[#0C4550]/10'}`}><FiClipboard size={16} /> Paste Numbers</button>
          </div>
          <form id="campaign-form" onSubmit={onSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <FormInput label="Campaign Name" name="campaignName" value={formData.campaignName} onChange={handleChange} placeholder="e.g., Diwali Sale 2024" icon={FiType} required />
              {formData.campaignMode === 'UPLOADED' && (
                <FormSelect label="Contact Group" name="contactGroupName" value={formData.contactGroupName} onChange={handleChange} icon={FiUsers} required={formData.campaignMode === 'UPLOADED'} options={contactGroupOptions} note={formData.contactType ? `Type: ${formData.contactType}` : "Select uploaded contacts"} />
              )}
              <FormSelect label="Sender ID" name="senderId" value={formData.senderId} onChange={handleChange} icon={FiUser} required options={senderIdOptions} />
              <FormSelect
                label="Template Name"
                name="templateName"
                value={formData.templateName}
                onChange={handleChange}
                icon={FiFileText}
                required
                options={[
                  { value: "", label: "Select Template Name", disabled: true },
                  ...filteredTemplates.map(t => ({ value: t.templateName, label: t.templateName }))
                ]}
                note={!formData.senderId ? "Select Sender ID first" : ""}
              />
              <FormInput
                label="Template ID"
                name="templateId"
                value={formData.templateId}
                readOnly
                placeholder="Auto-filled from template..."
                icon={FiHash}
              />
            </div>
            <div className="mt-2">
              <TemplateContentField
                label="Message Content"
                name="messageContent"
                value={formData.messageContent}
                onChange={handleChange}
                icon={FiMessageSquare}
                placeholder="Content auto-fills on Template Name selection..."
                charCount={formData.messageContent.length}
                maxLength={smsLimit}
                encodingLabel={encodingLabel}
                required
              />

              <AnimatePresence>
                {showLimitWarning && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-xl flex items-start gap-3 shadow-sm"
                  >
                    <div className="mt-0.5 text-orange-500">
                      <FiAlertCircle size={18} />
                    </div>
                    <div>
                      <p className="text-[11px] font-bold text-orange-800 uppercase">Message Limit Exceeded</p>
                      <p className="text-[10px] text-orange-700 font-medium leading-tight mt-0.5">
                        Your message exceeds the {smsLimit} character limit for {encodingLabel} encoding.
                        It will be charged as <span className="font-bold">2 or more messages</span> per contact.
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
            {formData.campaignMode === 'PASTED' && (
              <div className="mt-6 animate-fadeIn">
                <div className="flex justify-between items-center mb-2">
                  <label className="block text-sm font-semibold text-gray-700">Paste Numbers <span className="text-red-500 ml-1">*</span></label>
                  <span className={`text-xs font-bold px-2 py-1 rounded-full ${isOverLimit ? 'bg-red-100 text-red-600' : 'bg-[#E5F1F3] text-[#0C4550]'}`}>{validNumbersCount.toLocaleString()} / 100,000 Valid</span>
                </div>
                <div className="relative group">
                  <textarea name="rawNumbers" value={formData.rawNumbers} onChange={handleChange} placeholder="Paste your 10-digit numbers here, separated by space or commas..." rows="4" className={`w-full p-4 pl-4 pr-12 rounded-2xl bg-gray-50 border-2 outline-none resize-y transition-all duration-300 ease-in-out text-sm text-gray-700 leading-relaxed shadow-inner ${isOverLimit ? 'border-red-300 focus:border-red-500 bg-red-50/30' : 'border-gray-200 focus:border-[#126673] focus:bg-white'}`} required={formData.campaignMode === 'PASTED'} />
                  <div className="absolute right-3 bottom-4 text-gray-400 group-focus-within:text-[#126673] transition-colors"><FiFileText size={20} /></div>
                </div>
                <p className="mt-1 text-xs text-gray-500 text-right">Duplicates and invalid numbers are automatically filtered.</p>
              </div>
            )}

            <div className="mt-6 border-t border-gray-100 pt-6" ref={scheduleSectionRef}>
              <div className="flex items-center justify-between bg-indigo-50 p-4 rounded-xl border border-indigo-50">
                <div className="flex items-center gap-3">
                  <div className={`p-2 rounded-lg transition-colors bg-white text-indigo-600`}>
                    <FiCalendar size={20} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-indigo-600">Schedule Campaign</h4>
                    <p className="text-[11px] text-gray-600">Optional — if you want to schedule this campaign for later.</p>
                  </div>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" name="isScheduled" checked={formData.isScheduled} onChange={(e) => handleChange({ target: { name: 'isScheduled', value: e.target.checked } })} className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gray-800"></div>
                </label>
              </div>

              {formData.isScheduled && (
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 animate-fadeIn">
                  <FormInput
                    label="Schedule Date & Time"
                    name="scheduledAt"
                    type="datetime-local"
                    value={formData.scheduledAt}
                    onChange={handleChange}
                    icon={FiClock}
                    required={formData.isScheduled}
                    min={new Date().toISOString().slice(0, 16)}
                  />
                  <div className="flex items-center bg-blue-50/50 border border-blue-100 rounded-lg p-3">
                    <p className="text-[11px] text-slate-800 leading-tight">
                      <strong>Note:</strong> Campaign will automatically start at the selected time. Ensure your wallet has sufficient balance.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 flex flex-col sm:flex-row justify-between items-center gap-4 shrink-0">
          <div className="text-xs text-gray-500">{formData.campaignMode === 'PASTED' && isOverLimit && (<span className="text-red-600 font-semibold flex items-center gap-1"><FiX size={14} /> Exceeds 100,000 maximum limit</span>)}</div>
          <div className="flex justify-end gap-4 w-full sm:w-auto">
            <button type="button" onClick={onClose} className="px-6 py-2.5 text-gray-700 font-semibold rounded-xl border border-gray-300 bg-white shadow-sm transition-all duration-200 hover:bg-gray-100 hover:scale-105 active:scale-95">Cancel</button>
            <button type="submit" form="campaign-form" disabled={isSubmitting || (formData.campaignMode === 'PASTED' && (validNumbersCount === 0 || isOverLimit))} className="px-8 py-2.5 bg-[#0C4550] text-white font-semibold rounded-xl shadow-md transition-all duration-200 hover:bg-[#09353E] hover:shadow-lg hover:scale-105 active:scale-95 disabled:opacity-50 disabled:scale-100 disabled:cursor-not-allowed flex items-center gap-2">
              {isSubmitting ? (<><div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> Processing...</>) : (<><FiSend size={18} />Create Campaign</>)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const StartConfirmModal = ({ isOpen, onClose, onConfirm, campaign, walletBalance, isStarting }) => {
  if (!isOpen || !campaign) return null;
  const totalContacts = campaign.totalContacts || 0;
  const effectiveCost = campaign.effectiveCostPaise || 0;
  const smsRate = campaign.smsRatePaise || 0;
  const dltCharge = campaign.dltChargePaise || 0;
  const totalDeduction = totalContacts * effectiveCost;
  const balanceAfter = (walletBalance ?? 0) - totalDeduction;
  const hasEnoughBalance = (walletBalance ?? 0) >= totalDeduction;

  return (
    <div className="fixed inset-0 bg-gray-900/70 backdrop-blur-sm flex items-center justify-center p-4 z-[70] transition-all duration-300">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg transform transition-all scale-100 overflow-hidden">
        <div className="bg-[#0C4550] px-5 py-4 flex items-center justify-between">
          <div>
            <h3 className="text-base font-bold text-white leading-tight">Confirm Campaign</h3>
            <p className="text-[11px] text-white/70 mt-0.5 truncate max-w-[280px]">{campaign.campaignName || campaign.name}</p>
          </div>
          <button onClick={onClose} disabled={isStarting} className="p-1.5 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-colors disabled:opacity-40">
            <FiX size={18} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div className="flex items-center gap-2.5 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2">
            <FiAlertTriangle size={14} className="text-amber-500 shrink-0" />
            <p className="text-[11px] text-amber-800 leading-tight">
              Cost will be <strong>deducted immediately</strong> from your wallet when you click Start.
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
            <div className="grid grid-cols-2 divide-x divide-gray-200">
              <div className="p-3">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Campaign Volume</p>
                <div className="flex justify-between items-end">
                  <span className="text-xs text-gray-600">Total Contacts</span>
                  <span className="text-sm font-bold text-gray-900">{totalContacts.toLocaleString('en-IN')}</span>
                </div>
              </div>
              <div className="p-3">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Unit Rates</p>
                <div className="space-y-0.5">
                  <div className="flex justify-between text-[11px] text-gray-600">
                    <span>Base SMS Rate</span>
                    <span>{millipaiseToPaise(smsRate,4)} / SMS</span>
                  </div>
                  <div className="flex justify-between text-[11px] text-gray-600">
                    <span>DLT Charge</span>
                    <span>{millipaiseToPaise(dltCharge,4)} / SMS</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 bg-[#0C4550]/5 border-t border-gray-200">
              <div className="p-3">
                <p className="text-[10px] font-bold text-[#0C4550] uppercase tracking-wider">Effective Cost / SMS</p>
                <p className="text-lg font-bold text-[#0C4550]">{millipaiseToPaise(effectiveCost,4)}</p>
              </div>
              <div className="p-3 bg-[#0C4550] text-white">
                <p className="text-[10px] font-semibold text-white/70 uppercase tracking-wider">Total Deduction</p>
                <p className="text-lg font-bold">{paiseToRupees(totalDeduction)}</p>
              </div>
            </div>
          </div>

          <div className={`rounded-xl border p-3 ${hasEnoughBalance ? 'bg-emerald-50/50 border-emerald-100' : 'bg-red-50 border-red-100'}`}>
            <div className="flex items-center justify-between gap-4">
              <div className="flex flex-col">
                <span className="text-[10px] font-bold text-gray-400 uppercase">Available Balance</span>
                <span className={`text-sm font-bold ${hasEnoughBalance ? 'text-emerald-700' : 'text-red-600'}`}>
                  {walletBalance != null ? paiseToRupees(walletBalance) : '—'}
                </span>
              </div>
              <div className="h-8 w-px bg-gray-200"></div>
              <div className="flex flex-col">
                <span className="text-[10px] font-bold text-gray-400 uppercase">After Start</span>
                <span className="text-sm font-bold text-gray-800">
                  {walletBalance != null ? paiseToRupees(Math.max(0, balanceAfter)) : '—'}
                </span>
              </div>
            </div>

            {!hasEnoughBalance && walletBalance != null && (
              <div className="mt-2 pt-2 border-t border-red-100 flex items-center gap-2 text-red-700">
                <FiX size={12} className="shrink-0" />
                <p className="text-[11px] font-semibold text-center w-full">
                  Insufficient balance. Need {paiseToRupees(totalDeduction - walletBalance)} more.
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="px-5 py-3 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">
          <button type="button" onClick={onClose} disabled={isStarting} className="px-4 py-2 text-sm text-gray-600 font-semibold rounded-lg border border-gray-200 bg-white hover:bg-gray-50 transition-colors disabled:opacity-50">
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isStarting || !hasEnoughBalance || walletBalance == null}
            className="px-5 py-2 bg-[#0C4550] text-white text-sm font-bold rounded-lg shadow-sm transition-all hover:bg-[#09353E] hover:shadow-md active:scale-95 disabled:opacity-50 disabled:scale-100 flex items-center gap-2"
          >
            {isStarting ? (
              <><div className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" /> Starting...</>
            ) : (
              <><FiPlay size={16} /> Confirm & Start</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

const CampaignRow = ({ campaign, stats, processedCount, onStart, onPause, onResume, onViewStats, onViewReport, onRelaunch, isLoadingStats, isStatsVisible }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'DRAFT': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'SCHEDULED': return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'RUNNING': return 'bg-green-100 text-green-800 border-green-200';
      case 'PAUSED': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'COMPLETED': return 'bg-emerald-100 text-emerald-800 border-emerald-200';
      case 'STOPPED': return 'bg-red-100 text-red-800 border-red-200';
      case 'UPLOADING': return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'FAILED': return 'bg-red-100 text-red-800 border-red-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  const totalRecords = campaign.totalContacts || campaign.totalRecords || campaign.totalRecords || 0;
  const totalSent = processedCount ?? campaign.sentCount ?? campaign.totalSent ?? 0;
  const progress = totalRecords > 0 ? Math.min((totalSent / totalRecords) * 100, 100) : 0;
  const isActive = ACTIVE_STATUSES.includes(campaign.status);
  const isPastedData = campaign.contactGroupName === 'REDIS_PASTED_DATA';

  return (
    <>
      <tr className="bg-white hover:bg-gray-50 transition-colors border-b border-gray-200 last:border-b-0">
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex flex-col">
            <span className="text-sm font-bold text-gray-900">{campaign.name || campaign.campaignName}</span>
            <div className="mt-1 flex items-center gap-2">
              <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${getStatusColor(campaign.status)}`}>
                {campaign.status === 'UPLOADING' && <FiRefreshCw className="animate-spin w-3 h-3" />}
                {campaign.status}
              </span>
              {campaign.status === 'SCHEDULED' && campaign.scheduledAt && (
                <CountdownTimer targetDate={campaign.scheduledAt} />
              )}
            </div>
          </div>
        </td>
        <td className="px-6 py-4 whitespace-nowrap">
          <div className="flex flex-col space-y-1.5">
            <div className="flex items-center text-sm text-gray-600 gap-2">{isPastedData ? <FiClipboard size={14} className="text-indigo-400" /> : <FiUsers size={14} className="text-gray-400" />}<span className={`truncate max-w-[150px] ${isPastedData ? 'font-medium text-indigo-700 bg-indigo-50 px-2 py-0.5 rounded-md' : ''}`} title={isPastedData ? 'Pasted Numbers (Live)' : campaign.contactGroupName}>{isPastedData ? 'Pasted Numbers' : campaign.contactGroupName}</span></div>
            <div className="flex items-center text-[11px] text-gray-500 font-medium bg-gray-100 w-fit px-2 py-1 rounded gap-1.5"><FiCalendar size={12} className="text-gray-400" />{formatDateArray(campaign.createdAt)}</div>
          </div>
        </td>
        <td className="px-6 py-4 align-middle">
          {campaign.status === 'UPLOADING' ? (
            <div className="w-full max-w-[200px]">
              <div className="text-xs font-semibold text-gray-500 mb-1 flex items-center gap-2"><div className="w-2 h-2 bg-orange-500 rounded-full animate-ping"></div>System Processing...</div>
              <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden"><div className="h-full bg-orange-400 rounded-full w-1/2 animate-shimmer-fast"></div></div>
            </div>
          ) : campaign.status === 'SCHEDULED' ? (
            <div className="w-full max-w-[200px] bg-purple-50/50 p-2 rounded-lg border border-purple-100">
              <div className="flex items-center gap-1.5 text-[10px] font-bold text-purple-500 uppercase tracking-wider mb-1"><FiClock size={12} /> Scheduled Launch</div>
              <div className="text-[12px] font-bold text-slate-700 flex flex-col">
                <span>{formatDateArray(campaign.scheduledAt)}</span>
              </div>
            </div>
          ) : (
            <div className="w-full max-w-[200px]">
              <div className="flex justify-between items-center mb-1"><span className="text-xs font-bold text-gray-700">{Math.round(progress)}%</span><span className="text-xs text-gray-500 tabular-nums"><span className={isActive ? "text-[#126673] font-bold" : ""}>{totalSent.toLocaleString()}</span><span className="text-gray-400 font-medium"> / {totalRecords.toLocaleString()}</span></span></div>
              <div className="w-full h-2.5 bg-gray-100 rounded-full overflow-hidden shadow-inner"><div className="h-full bg-gradient-to-r from-[#0C4550] to-[#126673] rounded-full transition-all duration-700 ease-out relative" style={{ width: `${progress}%` }}>{isActive && progress < 100 && (<div className="absolute top-0 left-0 h-full w-8 bg-white/30 animate-shimmer"></div>)}</div></div>
              {campaign.status === 'RUNNING' && <div className="flex items-center gap-1 mt-1"><div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></div><span className="text-[10px] text-green-600 font-bold uppercase tracking-tight">Live</span></div>}
            </div>
          )}
        </td>
        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
          <div className="flex items-center justify-end gap-2">
            {['DRAFT', 'SCHEDULED'].includes(campaign.status) && (
              <button onClick={() => onStart(campaign, isPastedData)} className="text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1">
                <FiPlayCircle size={14} /> {campaign.status === 'SCHEDULED' ? 'Start Now' : 'Start'}
              </button>
            )}
            {campaign.status === 'RUNNING' && (<button onClick={() => onPause(campaign.id)} className="text-yellow-600 hover:text-yellow-900 bg-yellow-50 hover:bg-yellow-100 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1"><FiPause size={14} /> Pause</button>)}
            {campaign.status === 'PAUSED' && (<button onClick={() => onResume(campaign.id)} className="text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1"><FiPlay size={14} /> Resume</button>)}

            {['STOPPED', 'PAUSED', 'COMPLETED', 'RUNNING'].includes(campaign.status) && (
              <button
                type="button"
                onClick={() => onViewReport(campaign.id)}
                className="text-indigo-600 hover:text-indigo-900 bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1"
                title="View Detailed Report"
              >
                <FiEye size={14} /> View Report
              </button>
            )}

            {campaign.status === 'COMPLETED' && (
              <button
                type="button"
                onClick={() => onRelaunch(campaign)}
                className="text-teal-600 hover:text-teal-900 bg-teal-50 hover:bg-teal-100 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1"
                title="Retarget Contacts"
              >
                <FiTarget size={14} /> Retarget
              </button>
            )}

            <button onClick={onViewStats} disabled={isLoadingStats || campaign.status === 'UPLOADING' || campaign.status === 'FAILED'} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1 border ${isStatsVisible ? 'bg-gray-200 border-gray-400 text-gray-900' : 'bg-white border-gray-300 text-gray-600 hover:bg-gray-50'}`}>
              {isLoadingStats ? <div className="w-3 h-3 border-2 border-gray-600 border-t-transparent rounded-full animate-spin" /> : <><FiBarChart2 size={14} /> {isStatsVisible ? 'Hide' : 'Stats'}</>}
            </button>
          </div>
        </td>
      </tr>
      {isStatsVisible && stats && (
        <tr className="bg-gray-50 animate-fadeIn">
          <td colSpan="4" className="px-6 py-4">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 max-w-5xl mx-auto">
              {[
                { label: 'Total', value: stats.total || 0, color: 'text-gray-700' },
                { label: 'Submitted', value: stats.submitted || 0, color: 'text-purple-600' },
                { label: 'Pending', value: stats.pending || 0, color: 'text-blue-600' },
                { label: 'Delivered', value: stats.delivered || 0, color: 'text-emerald-600' },
                { label: 'Failed', value: stats.failed || 0, color: 'text-red-600' },
              ].map(({ label, value, color }) => (
                <div key={label} className="flex flex-col items-center justify-center p-3 bg-white border border-gray-200 rounded-lg shadow-sm"><span className={`text-lg font-bold ${color}`}>{value.toLocaleString()}</span><span className="text-xs font-medium text-gray-500 uppercase tracking-wide mt-1">{label}</span></div>
              ))}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

function BulkSmsForm() {
  const location = useLocation();
  const shouldHighlight = location.state?.triggerHighlight;
  const token = getAccessToken();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [campaignStats, setCampaignStats] = useState({});
  const [loadingCampaigns, setLoadingCampaigns] = useState(true);
  const [loadingStats, setLoadingStats] = useState({});
  const [visibleStats, setVisibleStats] = useState({});
  const visibleStatsRef = useRef({});
  useEffect(() => { visibleStatsRef.current = visibleStats; }, [visibleStats]);
  const [searchQuery, setSearchQuery] = useState("");
  const [processedCounts, setProcessedCounts] = useState({});
  const pollIntervalRef = useRef(null);
  const fetchedProcessedCountIds = useRef(new Set());
  const [dltData, setDltData] = useState({ peId: null, senderIds: [], templates: [] });
  const [contactGroups, setContactGroups] = useState([]);
  const [formData, setFormData] = useState({
    campaignMode: "UPLOADED", campaignName: "", contactGroupName: "", contactType: "",
    senderId: "", templateName: "", templateId: "", messageContent: "", rawNumbers: "",
    isScheduled: false, scheduledAt: ""
  });

  const [walletBalance, setWalletBalance] = useState(null);
  const [walletBalanceLoading, setWalletBalanceLoading] = useState(false);
  const [startConfirmModal, setStartConfirmModal] = useState({ isOpen: false, campaign: null, isPasted: false, isStarting: false });
  const [earlyStartConfirm, setEarlyStartConfirm] = useState({ isOpen: false, campaign: null, isPasted: false });
  const [reportModal, setReportModal] = useState({ isOpen: false, campaignId: null });
  const [relaunchModal, setRelaunchModal] = useState({ isOpen: false, campaign: null, isSubmitting: false });

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const fetchWalletBalance = useCallback(async () => {
    if (!token) return;
    setWalletBalanceLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/v1/wallet/balance`, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
      if (!res.ok) return;
      const data = await res.json();
      const liveBalance = data?.data?.liveBalancePaise ?? data?.liveBalancePaise ?? null;
      setWalletBalance(liveBalance);
    } catch (err) { console.warn("Wallet balance fetch failed:", err.message); }
    finally { setWalletBalanceLoading(false); }
  }, [token]);

  useEffect(() => { fetchWalletBalance(); }, [fetchWalletBalance]);

  const fetchLiveStats = useCallback(async (campaignId, userId) => {
    try {
      const response = await fetch(`${API_URL}/api/reports/campaigns/${campaignId}/live-stats?userId=${userId}`, { headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" } });
      if (response.ok) {
        const result = await response.json();
        setCampaignStats(prev => ({ ...prev, [campaignId]: result.data || result }));
      }
    } catch (error) { console.warn(`Live stats fetch failed for ${campaignId}:`, error.message); }
  }, [token]);

  const fetchProcessedCount = useCallback(async (campaignId) => {
    try {
      const res = await fetch(`${API_URL}/api/reports/campaigns/${campaignId}/processed-count`, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
      if (!res.ok) return;
      const data = await res.json();
      setProcessedCounts(prev => ({ ...prev, [campaignId]: data.processedCount ?? 0 }));
    } catch (err) { console.warn(`processedCount fetch failed for ${campaignId}:`, err.message); }
  }, [token]);

  useEffect(() => {
    if (!campaigns.length) return;
    const activeCampaigns = campaigns.filter(c => ACTIVE_STATUSES.includes(c.status));

    const completedWithData = campaigns.filter(c => ['COMPLETED', 'STOPPED'].includes(c.status) && !fetchedProcessedCountIds.current.has(c.id));
    completedWithData.forEach(c => {
      fetchedProcessedCountIds.current.add(c.id);
      fetchProcessedCount(c.id);
    });

    if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
    if (activeCampaigns.length === 0) return;

    activeCampaigns.forEach(c => {
      if (!fetchedProcessedCountIds.current.has(c.id)) {
        fetchedProcessedCountIds.current.add(c.id);
        fetchProcessedCount(c.id);
      }
    });

    pollIntervalRef.current = setInterval(() => {
      setCampaigns(latest => {
        const stillRunning = latest.filter(c => c.status === 'RUNNING');
        stillRunning.forEach(c => {
          if (visibleStatsRef.current[c.id]) fetchLiveStats(c.id, c.userId);
        });
        return latest;
      });
    }, POLL_INTERVAL_MS);

    return () => clearInterval(pollIntervalRef.current);
  }, [campaigns, fetchProcessedCount, fetchLiveStats]);

  useEffect(() => {
    const fetchDltAndContacts = async () => {
      if (!token) return;
      try {
        const headers = { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
        const [profileRes, senderRes, templatesRes, contactsRes] = await Promise.all([
          fetch(`${API_URL}/api/dlt/profile`, { headers }),
          fetch(`${API_URL}/api/dlt/sender-ids`, { headers }),
          fetch(`${API_URL}/api/dlt/templates`, { headers }),
          fetch(`${API_URL}/api/v1/uploads/metadata`, { headers }),
        ]);
        const profileData = profileRes.ok ? await profileRes.json() : { peId: "Not Registered" };
        const senderData = senderRes.ok ? await senderRes.json() : [];
        const templatesData = templatesRes.ok ? await templatesRes.json() : [];
        const contactsData = contactsRes.ok ? await contactsRes.json() : { data: [] };

        setDltData({ peId: profileData.peId, senderIds: senderData, templates: templatesData });
        setContactGroups(contactsData.data || []);
      } catch (error) { console.error("Error fetching DLT/Contacts setup:", error); }
    };
    fetchDltAndContacts();
  }, [token]);

  const fetchCampaigns = useCallback(async (isBackground = false) => {
    try {
      if (!isBackground) setLoadingCampaigns(true);
      const response = await fetch(`${API_URL}/api/v1/campaigns`, { method: "GET", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      setCampaigns(result.data || []);
    } catch (error) { console.error("Fetch Campaigns Error:", error); }
    finally { if (!isBackground) setLoadingCampaigns(false); }
  }, [token]);

  useEffect(() => { if (token) fetchCampaigns(); }, [token, fetchCampaigns]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contactGroupName") {
      const selectedGroup = contactGroups.find(c => c.contactGroupName === value);
      setFormData(prev => ({ ...prev, [name]: value, contactType: selectedGroup ? selectedGroup.contactType : "" }));
    } else if (name === "senderId") {
      setFormData(prev => ({ ...prev, [name]: value, templateName: "", templateId: "", messageContent: "" }));
    } else if (name === "templateName") {
      const template = dltData.templates.find(t => t.templateName === value);
      setFormData(prev => ({
        ...prev,
        templateName: value,
        templateId: template ? template.templateId : "",
        messageContent: template ? template.content : ""
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const isPastedMode = formData.campaignMode === 'PASTED';
    const endpoint = isPastedMode ? `${API_URL}/api/v1/campaigns/pasted` : `${API_URL}/api/v1/campaigns`;
    let payload = { campaignName: formData.campaignName, senderId: formData.senderId, templateId: formData.templateId, messageContent: formData.messageContent };
    if (formData.isScheduled && formData.scheduledAt) { payload.scheduledAt = new Date(formData.scheduledAt).toISOString(); }
    if (isPastedMode) { payload.rawNumbers = formData.rawNumbers; }
    else { payload.contactGroupName = formData.contactGroupName; payload.contactType = formData.contactType || "STATIC"; }
    try {
      const response = await fetch(endpoint, { method: "POST", headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" }, body: JSON.stringify(payload) });
      const result = await response.json();
      if (response.ok && result.success) {
        alert(`✅ Campaign created successfully!`);
        fetchCampaigns(); setIsModalOpen(false);
        setFormData({ campaignMode: formData.campaignMode, campaignName: "", contactGroupName: "", contactType: "", senderId: "", templateName: "", templateId: "", messageContent: "", rawNumbers: "", isScheduled: false, scheduledAt: "" });
      } else { alert("❌ Creation failed: " + (result.message || "Server Error")); }
    } catch { alert("❌ Network Error during creation."); }
    finally { setIsSubmitting(false); }
  };

  const handleRelaunchSubmit = async (relaunchData) => {
    setRelaunchModal(prev => ({ ...prev, isSubmitting: true }));
    let payload = {
      campaignName: relaunchData.campaignName,
      senderId: relaunchData.senderId,
      templateId: relaunchData.templateId,
      messageContent: relaunchData.messageContent
    };
    if (relaunchData.isScheduled && relaunchData.scheduledAt) {
      payload.scheduledAt = new Date(relaunchData.scheduledAt).toISOString();
    }

    const endpoint = relaunchData.targetAudience === 'FAILED'
      ? `${API_URL}/api/v1/campaigns/${relaunchModal.campaign.id}/recreate-from-failed`
      : `${API_URL}/api/v1/campaigns/${relaunchModal.campaign.id}/recreate-from-delivered`;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        alert(`✅ Retargeting Campaign created successfully!`);
        fetchCampaigns();
        setRelaunchModal({ isOpen: false, campaign: null, isSubmitting: false });
      } else {
        alert("❌ Retargeting failed: " + (result.message || "Server Error"));
      }
    } catch {
      alert("❌ Network Error during retargeting.");
    } finally {
      setRelaunchModal(prev => ({ ...prev, isSubmitting: false }));
    }
  };

  const handleAction = async (campaignOrId, action, isPastedData = false) => {
    if (action === 'start') {
      const campaign = typeof campaignOrId === 'object' ? campaignOrId : campaigns.find(c => c.id === campaignOrId);
      if (!campaign) return;
      if (campaign.status === 'SCHEDULED') { setEarlyStartConfirm({ isOpen: true, campaign, isPasted: isPastedData }); return; }
      await fetchWalletBalance();
      setStartConfirmModal({ isOpen: true, campaign, isPasted: isPastedData, isStarting: false });
      return;
    }
    const campaignId = typeof campaignOrId === 'string' ? campaignOrId : campaignOrId?.id;
    const campaign = campaigns.find(c => c.id === campaignId);
    try {
      let url = '', method = '';
      if (action === 'pause' || action === 'resume') { url = `${API_URL}/api/v1/artemis/${action}/${campaign.userId}/${campaignId}`; method = 'POST'; }
      const response = await fetch(url, { method, headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      alert(`✅ Campaign ${action} successful!`);
      fetchCampaigns();
    } catch (error) { alert(`❌ Failed to ${action} campaign: ` + error.message); }
  };

  const handleConfirmStart = async () => {
    const { campaign, isPasted } = startConfirmModal;
    if (!campaign) return;
    setStartConfirmModal(prev => ({ ...prev, isStarting: true }));
    try {
      const url = isPasted ? `${API_URL}/api/v1/campaigns/pasted/${campaign.id}/start` : `${API_URL}/api/v1/campaigns/${campaign.id}/start`;
      const response = await fetch(url, { method: 'PATCH', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Failed to start campaign');
      setStartConfirmModal({ isOpen: false, campaign: null, isPasted: false, isStarting: false });
      alert('✅ Campaign started successfully!');
      await Promise.all([fetchCampaigns(), fetchWalletBalance()]);
    } catch (error) { setStartConfirmModal(prev => ({ ...prev, isStarting: false })); alert(`❌ Failed to start campaign: ` + error.message); }
  };

  const handleViewStats = async (campaignId) => {
    if (visibleStats[campaignId]) { setVisibleStats(prev => ({ ...prev, [campaignId]: false })); return; }
    const campaign = campaigns.find(c => c.id === campaignId);
    if (!campaign || !campaign.userId) { alert("❌ User ID missing."); return; }
    setLoadingStats(prev => ({ ...prev, [campaignId]: true }));
    try { await fetchLiveStats(campaignId, campaign.userId); setVisibleStats(prev => ({ ...prev, [campaignId]: true })); }
    finally { setLoadingStats(prev => ({ ...prev, [campaignId]: false })); }
  };

  const contactGroupOptions = [
    { value: "", label: "Select Contact Group", disabled: true },
    ...contactGroups.map(c => ({
      value: c.contactGroupName,
      label: `${c.contactGroupName} (${c.totalContacts || 0})`
    }))
  ];

  const senderIdOptions = [{ value: "", label: "Select Sender ID", disabled: true }, ...dltData.senderIds.map(s => ({ value: s.header, label: s.header }))];
  const filteredCampaigns = campaigns.filter(c => (c.name || c.campaignName || '').toLowerCase().includes(searchQuery.toLowerCase()));
  const sortedCampaigns = [...filteredCampaigns].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const totalPages = Math.ceil(sortedCampaigns.length / recordsPerPage);
  const currentRecords = sortedCampaigns.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);

  const paginate = (pageNumber) => { if (pageNumber >= 1 && pageNumber <= totalPages) setCurrentPage(pageNumber); };
  useEffect(() => { setCurrentPage(1); }, [searchQuery]);

  return (
    <div className="min-h-screen bg-[#F0EFEB]">
      <style jsx>{`
        @keyframes fadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-fadeIn { animation: fadeIn 0.2s ease-out forwards; }
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap'); 
        .font-manrope { font-family: 'Manrope', sans-serif; }
      `}</style>

      <CampaignModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
        formData={formData}
        handleChange={handleChange}
        isSubmitting={isSubmitting}
        senderIdOptions={senderIdOptions}
        contactGroupOptions={contactGroupOptions}
        templates={dltData.templates}
      />

      <RelaunchModal
        isOpen={relaunchModal.isOpen}
        onClose={() => setRelaunchModal({ isOpen: false, campaign: null, isSubmitting: false })}
        onSubmit={handleRelaunchSubmit}
        campaign={relaunchModal.campaign}
        senderIdOptions={senderIdOptions}
        dltTemplates={dltData.templates}
        isSubmitting={relaunchModal.isSubmitting}
      />

      <EarlyStartModal
        isOpen={earlyStartConfirm.isOpen}
        campaign={earlyStartConfirm.campaign}
        onClose={() => setEarlyStartConfirm({ isOpen: false, campaign: null, isPasted: false })}
        onConfirm={async () => {
          const c = earlyStartConfirm.campaign; const p = earlyStartConfirm.isPasted;
          setEarlyStartConfirm({ isOpen: false, campaign: null, isPasted: false });
          await fetchWalletBalance(); setStartConfirmModal({ isOpen: true, campaign: c, isPasted: p, isStarting: false });
        }}
      />

      <ViewReportModal
        isOpen={reportModal.isOpen}
        campaignId={reportModal.campaignId}
        onClose={() => setReportModal({ isOpen: false, campaignId: null })}
      />

      <StartConfirmModal
        isOpen={startConfirmModal.isOpen}
        onClose={() => !startConfirmModal.isStarting && setStartConfirmModal({ isOpen: false, campaign: null, isPasted: false, isStarting: false })}
        onConfirm={handleConfirmStart}
        campaign={startConfirmModal.campaign}
        walletBalance={walletBalance}
        isStarting={startConfirmModal.isStarting}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div><h1 className="text-3xl font-bold text-gray-900">Bulk SMS Campaigns</h1><p className="text-gray-600 mt-2">Manage your campaigns</p></div>
          <div className="flex gap-3 items-center">
            <button onClick={() => fetchCampaigns(false)} className="px-4 py-2.5 bg-white border rounded-lg hover:bg-gray-50 transition-colors"><FiRefreshCw size={14} className={loadingCampaigns ? "animate-spin" : ""} /></button>
            <button onClick={() => setIsModalOpen(true)} className={`flex items-center gap-2 px-6 py-3 bg-[#0C4550] text-white rounded-xl font-bold transition-all duration-300 hover:bg-[#0A3A43] hover:scale-[1.02] active:scale-95 group ${shouldHighlight ? 'animate-bounce' : ''}`}><FiPlus size={18} className="transition-transform duration-300 group-hover:rotate-90" /> New Campaign</button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm"><div className="flex items-center justify-between"><div><p className="text-sm font-medium text-gray-600">Total Campaigns</p><p className="text-2xl font-bold text-gray-900 mt-1">{campaigns.length}</p></div><div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center"><FiFileText className="w-6 h-6 text-blue-600" /></div></div></div>
          <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm"><div className="flex items-center justify-between"><div><p className="text-sm font-medium text-gray-600">Running</p><p className="text-2xl font-bold text-green-600 mt-1">{campaigns.filter(c => c.status === 'RUNNING').length}</p></div><div className="w-12 h-12 rounded-lg bg-green-50 flex items-center justify-center"><FiPlay className="w-6 h-6 text-green-600" /></div></div></div>
          <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm"><div className="flex items-center justify-between"><div><p className="text-sm font-medium text-gray-600">Draft</p><p className="text-2xl font-bold text-blue-600 mt-1">{campaigns.filter(c => c.status === 'DRAFT').length}</p></div><div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center"><FiClock className="w-6 h-6 text-blue-600" /></div></div></div>
          <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm"><div className="flex items-center justify-between"><div><p className="text-sm font-medium text-gray-600">Completed</p><p className="text-2xl font-bold text-emerald-600 mt-1">{campaigns.filter(c => c.status === 'COMPLETED').length}</p></div><div className="w-12 h-12 rounded-lg bg-emerald-50 flex items-center justify-center"><FiCheckCircle className="w-6 h-6 text-emerald-600" /></div></div></div>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
          <div className="p-6 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <h2 className="text-xl font-semibold text-gray-800">All Campaigns</h2>
            <div className="relative">
              <input type="text" placeholder="Search by name..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full sm:w-64 pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#126673] transition-all" />
              <FiSearch className="absolute left-3 top-2.5 text-[#0C4550]" size={16} />
            </div>
          </div>
          {loadingCampaigns ? (
            <div className="text-center py-12"><div className="w-12 h-12 border-4 border-[#0C4550] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div><p>Loading...</p></div>
          ) : sortedCampaigns.length === 0 ? (
            <div className="text-center py-12"><FiFileText className="w-16 h-16 text-gray-300 mx-auto mb-4" /><p>No campaigns found.</p></div>
          ) : (
            <>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Campaign Name & Status</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Contact Group & Date</th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-gray-500 uppercase">Progress / Schedule</th>
                      <th className="px-6 py-3 text-right text-xs font-bold text-gray-500 uppercase">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {currentRecords.map(c => (
                      <CampaignRow
                        key={c.id}
                        campaign={c}
                        stats={campaignStats[c.id]}
                        processedCount={processedCounts[c.id]}
                        isStatsVisible={visibleStats[c.id]}
                        isLoadingStats={loadingStats[c.id]}
                        onStart={(campaign, isPasted) => handleAction(campaign, 'start', isPasted)}
                        onPause={() => handleAction(c.id, 'pause')}
                        onResume={() => handleAction(c.id, 'resume')}
                        onViewStats={() => handleViewStats(c.id)}
                        onViewReport={(id) => setReportModal({ isOpen: true, campaignId: id })}
                        onRelaunch={(campaignData) => setRelaunchModal({ isOpen: true, campaign: campaignData, isSubmitting: false })}
                      />
                    ))}
                  </tbody>
                </table>
              </div>

              {totalPages > 1 && (
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
                  <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Showing <span className="text-[#0C4550]">{((currentPage - 1) * recordsPerPage) + 1}-{Math.min(currentPage * recordsPerPage, sortedCampaigns.length)}</span> of <span className="text-[#0C4550]">{sortedCampaigns.length}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-lg border border-gray-300 bg-white disabled:opacity-40"><FiChevronLeft size={16} /></button>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-lg border border-gray-300 bg-white disabled:opacity-40"><FiChevronRight size={16} /></button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BulkSmsForm;